import { lazy } from 'react';
import { Route } from 'react-router';
import { route } from '../config';
import { useNewMissionAnnouncer } from '../speech';

const TableauLoader = lazy(() => import('./TableauLoader'));

export default function TableauPage() {
  useNewMissionAnnouncer();

  return <Route path={route} component={TableauLoader} />;
}
